SupportThanksForContactingTemplate = require('../../thanks_for_contacting.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $
SharedWidgetLayoutView = require('../../../shared/frontend/views/widget_layout_veiw')
SupportUtilsHelper = require('../helpers/utils')

class SupportTicketSuccessView extends Backbone.View
  className: 'ticket-success'

  events :
    'click #needHelpAgain' : "needMoreHelpHandler"

  initialize: ->
    @I18nScope = 'modules.support'
    @template = SupportThanksForContactingTemplate
    @id = 'ticket-success'

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)
    @hideComponents()
    @showComponents()

  toHash: ->
    merchantName = Groupon.Support.currentOrder?.merchant?.name || ""
    hash =
      currentUser: currentUser
      showFooter : @shouldShowFooter()
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant
      merchant_to_contact: I18n.translate('js.modules.support.merchant_to_contact', {merchantName})
      refund_request_submitted: @isRefundEligible()
      greeting_text: @getGreetingText()
      showDefaultThankYouMsg: true
      isDefaultflow: true
    @setGetBackMsgType hash
    hash

  shouldShowFooter: () ->
   checkIfIsUSByCountry(window.country.name) && not SharedWidgetLayoutView.isWidgetLayoutEnabled()

  getGreetingText: () ->
    if @isRefundEligible()
      I18n.translate('js.modules.support.request_submitted_successfully')
    else
      I18n.translate('js.modules.support.thankcs')

  isRefundEligible: () ->
    Groupon.Support.ContentModel.isRefundEligible

  setGetBackMsgType: (hash)->
    if @isUrgentTicket()
      hash.twoHoursGetBackMsg = true
    else
      hash.defaultGetBackmsg = true

  isUrgentTicket:->
    if isUS() and checkIfCategoryIsAboutEditingOrCancelling()
      (isCurrentOrderGoodsDeal() and isOrderPurchasedWithinHours(2)) or
      (isCurrentOrderLiveDeal() and isOrderPurchasedWithinHours(24))
    else
      false

  hideComponents: ->
    SupportUtilsHelper.hideFloatingBoldChat()
    unless window.isUS()
      $('.module-body.intl-footer').children().addClass('hide')
      $('.module-body.intl-footer').addClass('hidden-footer-content-intl')

  showComponents: ->
    SharedWidgetLayoutView.showWidgets('ticket-success')

  needMoreHelpHandler: ->
    redirectToHelpWizard()

  close: ->

module.exports = SupportTicketSuccessView
